<template>
  <landing-page
    :chamber="config.key"
    :chamberTitle="config.name"
    :loading="loading"
    :models="models"
    :currentModel="model"
    :landingModels="landingModels">
    <span slot="page-title">2020 {{ config.name }} Elections Model</span>
  </landing-page>
</template>

<script>
import LandingMixin from '@/mixins/landingPage'

const name = 'senate_landing'

const mixins = [
  LandingMixin
]

const props = {
  config: {
    type: Object,
    default: () => {
      return {
        key: 'senate',
        name: 'Senate',
        param: 'SENATE'
      }
    }
  }
}

export default {
  name,
  mixins,
  props,
  metaInfo: {
    title: 'Senate',
    meta: [
      {
        vmid: 'og:title',
        name: 'og:title',
        content: 'Senate'
      }, {
        vmid: 'twitter:title',
        name: 'twitter:title',
        content: 'Senate'
      }, {
        vmid: 'description',
        name: 'description',
        content: '2020 U.S. election predictions for President, Senate and House Congressional elections. Includes model-driven predictions for key President, Senate and House races, polling and district information, and model simulations updated daily.'
      }, {
        vmid: 'og:description',
        name: 'og:description',
        content: '2020 U.S. election predictions for President, Senate and House Congressional elections. Includes model-driven predictions for key President, Senate and House races, polling and district information, and model simulations updated daily.'
      }, {
        vmid: 'twitter:description',
        name: 'twitter:description',
        content: '2020 U.S. election predictions for President, Senate and House Congressional elections. Includes model-driven predictions for key President, Senate and House races, polling and district information, and model simulations updated daily.'
      }
    ]
  }
}
</script>
